import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { OutletContext } from "../../App";
import {
  useUpdateCampaignEndDate,
} from "../../services/campaign/index";
import { FormDataFilterCampaign } from "./campaign-interface";
import { useFormContext } from 'react-hook-form';
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MoreVertIcon from "../../assets/icons/MoreVertIcon.svg";
import EditIcon from "../../assets/icons/Icon-edit.svg";
import DeleteIcon from "../../assets/icons/Icon-delete.svg";
import DialogEdit from "../campaignSummary/DialogEdit";
import DialogDelete from "../campaignSummary/DialogDelete";
import { useAppMe } from "../../services/okta";
import { useSimulationParams } from "../../shared/hooks/useSimulationParams";

interface OptionsMenuProps {
  id?: string | null;
  name: string;
  status: string;
}

const OptionsMenu = ({ id, name, status }: OptionsMenuProps) => {
  const navigate = useNavigate();
  const { createLink } = useSimulationParams();
  const { setValue, getValues } = useFormContext<FormDataFilterCampaign>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const { setAlert } = useOutletContext<OutletContext>();

  const { data: dataAppMe } = useAppMe({});
  const user = dataAppMe?.data?.user_id;

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const { mutate: deleteCampaign, isPending: isPendingDeleteCampaign } = useUpdateCampaignEndDate({
    user: user,
    campaignName: name,
    options: {
      onSuccess: (res: any) => {
        if (res.data.status === "Error") {
          const currentRefresh = getValues('refreshKey') || 0;
          setValue('refreshKey', currentRefresh + 1);
          setValue('deletePending', false);
          setAlert({
            alertType: "warning",
            alertMsg: res.data.message ||"Campaign not deleted successfully",
          });
        } else {
          const currentRefresh = getValues('refreshKey') || 0;
          setValue('refreshKey', currentRefresh + 1);
          setValue('deletePending', false);
          setAlert({
            alertType: "success",
            alertMsg: res.data.message || "Campaign deleted successfully",
          });
        }
      },
      onError: (err: any) => {
        setAlert({
          alertType: "error",
          alertMsg: `Error deleting campaign ${err}`,
        });
      },
    },
  });

  const handleEditClick = () => {
    setEditDialogOpen(true);
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setEditDialogOpen(false);
    setDeleteDialogOpen(false);
  };

  const handleEdit = () => {
    setEditDialogOpen(false);
    navigate(createLink(`/create/campaigns?id=${id}`));
    handleMenuClose();
  };

  const handleDeleteClick = () => {

    setDeleteDialogOpen(true);
    handleMenuClose();
  };

  const handleDelete = () => {
    setDeleteDialogOpen(false);
    if (id && user && name) {
      setValue('deletePending', true);
      deleteCampaign({
        campaignId: id,
        user: user,
        campaignName: name,
      });
    }
    handleMenuClose();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="options-menu"
        aria-haspopup="true"
        onClick={handleMenuOpen}
        size="small"
      >
        <img className="no-border__icon" src={MoreVertIcon} alt="Folder Icon" />
      </IconButton>
      <Menu
        id="options-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ borderRadius: 12 }}
      >
        <MenuItem onClick={handleEditClick}>
          <ListItemIcon>
            <img className="no-border__icon" src={EditIcon} alt="Folder Icon" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <ListItemIcon>
            <img className="no-border__icon" src={DeleteIcon} alt="Folder Icon" />
          </ListItemIcon>
          <ListItemText sx={{ color: "#F1181B" }}>Delete</ListItemText>
        </MenuItem>
      </Menu>
      <DialogEdit
        open={editDialogOpen}
        onClose={handleDialogClose}
        onEdit={handleEdit}
        id={id}
        name={name}
        status={status}
      ></DialogEdit>
      <DialogDelete
        open={deleteDialogOpen}
        onClose={handleDialogClose}
        onDelete={handleDelete}
        id={id}
        name={name}
        status={status}
      ></DialogDelete>
    </>
  );
};

export default OptionsMenu;